/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1ExamCorrectionGridExampublishidQueryResponse,
  GetApiV1ExamCorrectionGridExampublishidPathParams,
  GetApiV1ExamCorrectionGridExampublishidQueryParams,
  GetApiV1ExamCorrectionGridExampublishid400,
  GetApiV1ExamCorrectionGridExampublishid401,
  GetApiV1ExamCorrectionGridExampublishid500,
} from "../../types/examCorrectionDashboardController/GetApiV1ExamCorrectionGridExampublishid.ts";

function getGetApiV1ExamCorrectionGridExampublishidUrl(
  examPublishId: GetApiV1ExamCorrectionGridExampublishidPathParams["examPublishId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/exam/correction-grid/${examPublishId}` as const,
  };
  return res;
}

/**
 * @description Retorna a subgrade de correção de texto para um item específico do exame dentro de uma publicação de exame com paginação. **(Requer Authorization para autenticação)**
 * @summary Subgrade de correção de exame de carga (Requer Authorization para autenticação)
 * {@link /api/v1/exam/correction-grid/:examPublishId}
 */
export async function getApiV1ExamCorrectionGridExampublishid(
  examPublishId: GetApiV1ExamCorrectionGridExampublishidPathParams["examPublishId"],
  params?: GetApiV1ExamCorrectionGridExampublishidQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1ExamCorrectionGridExampublishidQueryResponse,
    ResponseErrorConfig<
      | GetApiV1ExamCorrectionGridExampublishid400
      | GetApiV1ExamCorrectionGridExampublishid401
      | GetApiV1ExamCorrectionGridExampublishid500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1ExamCorrectionGridExampublishidUrl(
      examPublishId,
    ).url.toString(),
    params,
    ...requestConfig,
  });
  return res.data;
}
